export default {
  'corentin-prost': [
    '04',
    '05',
    '06',
    '13',
    '30',
    '38',
    '43',
    '69',
    '73',
    '74',
    '83',
    '84',
    '02',
    '08',
    '18',
    '75',
    '77',
    '01',
    '03',
    '23',
    '24',
    '40',
    '42',
    '10',
    '21',
    '12',
    '15',
    '16',
  ],
  'jean-marie-robin': [
    '50',
    '51',
    '53',
    '59',
    '60',
    '61',
    '62',
    '76',
    '79',
    '80',
    '87',
    '35',
    '58',
    '70',
    '71',
    '78',
    '90',
    '91',
    '92',
    '93',
    '94',
    '27',
    '28',
    '36',
    '45',
    '48',
    '26',
  ],
  'eddy-alfocea': [
    '09',
    '34',
    '66',
    '11',
    '17',
    '49',
    '25',
    '67',
    '68',
    '44',
    '85',
    '39',
    '52',
    '55',
    '57',
    '31',
    '07',
    '95',
    '46',
    '47',
    '63',
    '64',
    '65',
    '89',
    '19',
    '81',
    '82',
    '32',
    '14',
  ],
  'william-gouin': ['33'],
  'harold-paireault': ['37', '86', '41', '72'],
  'cedric-cyrille': ['56', '22', '29'],
  'olivier-pernot': ['54', '88'],
};
